import { ApiProperty } from '@nestjs/swagger';
import { User } from '../../user/entities/user.entity';
import { File } from '../../file/entities/file.entity';
import { UserResponseDto } from '../../user/dto/user-response.dto';
import { FileResponseDto } from '../../file/dto/file-response.dto';
import { ChapterResponseDto } from '@/modules/chapter/dto/chapter-response.dto';
import { TagResponseDto } from './tag-response.dto';

export class NewsfeedResponseDto {
    @ApiProperty({
        description: 'The unique identifier of the newsfeed',
        example: 1
    })
    id: number;

    @ApiProperty({
        description: 'The user who created the newsfeed',
        type: UserResponseDto
    })
    user: User;

    @ApiProperty({
        description: 'The urls of the newsfeed, otherwise provide empty array',
        type: [FileResponseDto]
    })
    files?: File[];

    @ApiProperty({
        description: 'The title of the newsfeed',
        example: 'Important Announcement'
    })
    title: string;

    @ApiProperty({
        description: 'The subject of the newsfeed',
        example: 'Company Update'
    })
    subject: string;

    @ApiProperty({
        description: 'The detailed description of the newsfeed',
        example: 'We are excited to announce our new features...'
    })
    description?: string;

    @ApiProperty({
        description: 'The audio of the newsfeed',
        example: 'https://example.com/audio.mp3',
    })
    audio?: string;

    @ApiProperty({
        description: 'The timestamp when the newsfeed was created',
        example: '2025-09-03T10:00:00Z',
    })
    created_at: Date;

    @ApiProperty({
        description: 'The timestamp when the newsfeed was last updated',
        example: '2025-09-03T10:00:00Z',
    })
    updated_at: Date;

    @ApiProperty({
        description: 'The tags of the newsfeed',
        type: [TagResponseDto]
    })
    tags: TagResponseDto[];

    @ApiProperty({
        description: 'The chapter of the newsfeed',
        type: ChapterResponseDto
    })
    chapter?: ChapterResponseDto;
}
